export const flames = [
  {
    id: "flame-sky",
    name: "大空",
    en: "Sky",
    color: "橙",
    meaning: "调和",
    desc: "纲吉所持有的属性，也是彭格列首领一脉的核心火焰。它的特点不是破坏力，而是调和与包容其他属性，象征着把不同类型的人聚在一起的能力。",
  },
  {
    id: "flame-storm",
    name: "岚",
    en: "Storm",
    color: "红",
    meaning: "分解与破坏",
    desc: "狱寺隼人的属性。以强烈的破坏力见长，适合正面撕裂对手的防御，但使用者也必须承受相应的风险与消耗。",
  },
  {
    id: "flame-rain",
    name: "雨",
    en: "Rain",
    color: "蓝",
    meaning: "镇静",
    desc: "山本武的属性。作用是压制与平息，能让激烈的战斗节奏慢下来。在团队中，它代表着稳定与冷静的一方。",
  },
  {
    id: "flame-sun",
    name: "晴",
    en: "Sun",
    color: "黄",
    meaning: "活化",
    desc: "笹川了平的属性，里包恩同样使用这一属性。核心是加速与活化，既能强化自身，也能在支援与恢复上发挥独特作用。",
  },
  {
    id: "flame-thunder",
    name: "雷",
    en: "Thunder",
    color: "绿",
    meaning: "硬化",
    desc: "蓝波与伽马的属性。以防御与硬度著称，能够抵挡强力攻击，是团队里承担正面抗压任务的一类火焰。",
  },
  {
    id: "flame-cloud",
    name: "云",
    en: "Cloud",
    color: "紫",
    meaning: "增殖",
    desc: "云雀恭弥的属性。特点是不断增殖与扩散，以数量和规模的持续增长形成压制，与云雀独来独往的作风形成有趣的呼应。",
  },
  {
    id: "flame-mist",
    name: "雾",
    en: "Mist",
    color: "靛",
    meaning: "构筑",
    desc: "六道骸与库洛姆的属性。擅长建造与幻术，能够制造虚假的影像与场景。它的价值往往不在正面战斗力，而在信息与心理层面的干扰。",
  },
];

export const flameSystemFacts = [
  {
    id: "sys-1",
    icon: "ri-goblet-line",
    title: "戒指",
    desc: "早期以彭格列戒指为核心，是家族身份的象征，也是释放火焰的媒介。随着剧情推进，戒指本身也经历了升级与换代。",
  },
  {
    id: "sys-2",
    icon: "ri-archive-2-line",
    title: "匣兵器",
    desc: "在未来篇引入，把火焰封存进匣子中，开匣即可召出武器或生物。它让战斗从单纯比拼火焰，变成结合战术与资源的组合博弈。",
  },
  {
    id: "sys-3",
    icon: "ri-fire-line",
    title: "七属性",
    desc: "大空、岚、雨、晴、雷、云、雾构成作品的基础力量框架。后期又补充了大地等新属性，使原有体系进一步扩张。",
  },
  {
    id: "sys-4",
    icon: "ri-heart-3-line",
    title: "觉悟",
    desc: "作品的底层设定是：火焰的强弱与使用者的决心直接挂钩。这也解释了为什么纲吉的突破总是发生在心理防线被击穿的瞬间。",
  },
];